import React from 'react'
import MaterialTable from 'material-table';
import { useTheme } from '@material-ui/core';
import { useAuthContext } from 'hooks/useAuthContext';
import Button from '@material-ui/core/Button';
import withAppStyles from 'HOCs/withAppStyles';
import withEditFunctions from 'HOCs/withEditFunctions';
import withInspectionLink from 'HOCs/withInspectionLink';

const Grid = ({ columns, title, getRecords, selectedProject, component, formPath, deleteRecord, enable={"delete": true, "edit" : true}, selection = { "display": false } , data = [], options, localization, inspectionColumnTitle}) => {
    const theme = useTheme();
    const { role } = useAuthContext();


    // Conditionally wrap with withInspectionLink if inspectionColumnTitle is provided
    const BaseGrid = inspectionColumnTitle
        ? withInspectionLink(
            withAppStyles(MaterialTable, { theme, getRecords, defaultFilters: {projectId: selectedProject} }),
            { inspectionColumnTitle }
          )
        : withAppStyles(MaterialTable, { theme, getRecords, defaultFilters: {projectId: selectedProject} });

    const GridWithAppStyles = withEditFunctions(BaseGrid, {role, formPath, deleteRecord, canUpdate: enable.update, canDelete: enable.delete, selectedProject, component})

    return (
        <GridWithAppStyles
            style={{ boxShadow: "0 0 0 0" }}
            options={{
                ...options,
                maxBodyHeight: '800px',
                headerStyle: {
                    position: "sticky",
                    top: "0"
                  },
            }}
            padding="default"
            columns={columns.map(col => { return col })}
            title={title}
            actions={selection.display ? [
                {
                    tooltip: selection.tooltip,
                    icon: () => <Button variant="outlined">{selection.btnText}</Button>,
                    onClick: (evt, data) => selection.callback(data)
                }
            ] : []
            }
            localization={{...localization}}
        />
    )
}

export default Grid